import React from 'react';
import { useForm } from 'react-hook-form';
import { capitalize } from '../../helpers/formatters';
import { Icon } from '../common/ui/Icon';

export const CategoryForm = ({ model: category = {}, mode = 'show', onSubmit, onReset }) => {
    const {
        formState: { errors },
        handleSubmit,
        register,
        watch
    } = useForm({
        defaultValues: category
    });

    const [icon] = watch(['icon']);

    const validations = {
        icon: {
            required: 'Icon is required.',
            minLength: {
                value: 3,
                message: 'Icon must be at least 3 characters long.'
            }
        },
        name: {
            required: 'Name is required.',
            minLength: {
                value: 3,
                message: 'Name must be at least 3 characters long.'
            }
        }
    };

    return (
        <form className="category-form" onSubmit={handleSubmit(onSubmit)} onReset={onReset}>
            <div className="row">
                <div className="col-12 d-flex justify-content-center align-items-center">
                    <Icon icon={icon} size="5x"></Icon>
                </div>
                <div className="col-12 mb-3">
                    <label htmlFor="categoryIcon" className="form-label">
                        Icon
                    </label>
                    <input
                        {...register('icon', validations.icon)}
                        type="text"
                        readOnly={mode == 'show'}
                        className={`form-control ${errors.icon ? 'is-invalid' : ''}`}
                        id="categoryIcon"
                    />
                    {errors.icon && (
                        <div className="invalid-feedback d-block">{errors.icon.message}</div>
                    )}
                </div>
                <div className="col-12 mb-3">
                    <label htmlFor="categoryName" className="form-label">
                        Name
                    </label>
                    <input
                        {...register('name', validations.name)}
                        type="text"
                        readOnly={mode == 'show'}
                        className={`form-control ${errors.name ? 'is-invalid' : ''}`}
                        id="categoryName"
                    />
                    {errors.name && (
                        <div className="invalid-feedback d-block">{errors.name.message}</div>
                    )}
                </div>
                <div className="col-12 mb-3">
                    <label htmlFor="categoryDescription" className="form-label">
                        Description
                    </label>
                    <textarea
                        {...register('description')}
                        readOnly={mode == 'show'}
                        className="form-control"
                        id="categoryDescription"
                        rows="6"
                    />
                </div>
            </div>
            {mode === 'show' && (
                <div className="d-grid col-sm-6 col-md-4 col-lg-3">
                    <button onClick={onReset} type="button" className="btn btn-outline-secondary">
                        Close
                    </button>
                </div>
            )}
            {mode !== 'show' && (
                <div className="row my-3">
                    <div className="d-grid order-1 order-sm-0 col-sm-6 col-md-4 col-lg-3 mb-3 mb-sm-0">
                        <button className="btn btn-outline-secondary" type="reset">
                            Cancel
                        </button>
                    </div>
                    <div className="d-grid order-0 order-sm-1 col-sm-6 col-md-4 col-lg-3 offset-md-4 offset-lg-6 mb-3 mb-sm-0">
                        <button className="btn btn-primary" type="submit">
                            {capitalize(mode)}
                        </button>
                    </div>
                </div>
            )}
        </form>
    );
};
